export default class ValidationError extends Error {
  constructor(messages) {
    super('ValidationError');
    this.name = 'ValidationError';
    this.messages = messages;
  }
}
